export const translations = {
  es: {
    // Auth
    backofficeTitle: 'Tienda Backoffice',
    loginSubtitle: 'Elige tu método de acceso',
    continueWithGoogle: 'Continuar con Google',
    continueWithEmail: 'Continuar con Email',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    emailPlaceholder: 'tu@email.com',
    passwordPlaceholder: '••••••••',
    login: 'Iniciar Sesión',
    loggingIn: 'Iniciando sesión...',
    register: 'Registrarse',
    registering: 'Registrando...',
    noAccount: '¿No tienes cuenta?',
    createAccount: 'Crear cuenta',
    alreadyHaveAccount: '¿Ya tienes cuenta?',
    signIn: 'Inicia sesión',
    backToOptions: 'Volver a opciones',
    loginFailed: 'Error al iniciar sesión',
    googleLoginFailed: 'Error al iniciar sesión con Google',
    invalidCredentials: 'Email o contraseña incorrectos',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    registrationFailed: 'Error al crear la cuenta',

    // Navigation
    dashboard: 'Dashboard',
    products: 'Productos',
    categories: 'Categorías',
    orders: 'Órdenes',
    logout: 'Cerrar Sesión',

    // Dashboard
    welcomeBackoffice: 'Bienvenido al backoffice de la tienda',
    totalProducts: 'Total Productos',
    inStock: 'En Stock',
    outOfStock: 'Sin Stock',
    catalogSummary: 'Resumen del Catálogo',
    totalCategories: 'Categorías',
    activeCategories: 'Categorías activas',
    availableProducts: 'Productos disponibles',
    productsOutOfStock: 'Productos sin stock',
    quickActions: 'Acciones Rápidas',
    viewAllProducts: 'Ver todos los productos',
    manageCategories: 'Gestionar categorías',
    viewOrders: 'Ver órdenes',

    // Products
    manageProducts: 'Gestiona tu catálogo de productos',
    newProduct: '+ Nuevo Producto',
    searchByName: 'Buscar por nombre...',
    allStatuses: 'Todos los estados',
    withStock: 'Con stock',
    noStock: 'Sin stock',
    product: 'Producto',
    category: 'Categoría',
    price: 'Precio',
    status: 'Estado',
    actions: 'Acciones',
    noProductsFound: 'No se encontraron productos',
    view: 'Ver',
    delete: 'Eliminar',
    showing: 'Mostrando',
    of: 'de',

    // Product Form
    editProduct: 'Editar Producto',
    createProduct: 'Crear Producto',
    name: 'Nombre',
    description: 'Descripción',
    stock: 'Stock',
    selectCategory: 'Selecciona una categoría',
    imageUrl: 'URL de Imagen',
    cancel: 'Cancelar',
    update: 'Actualizar',
    create: 'Crear',
    namePlaceholder: 'Nombre del producto',
    descriptionPlaceholder: 'Descripción del producto',
    pricePlaceholder: '0.00',
    stockPlaceholder: '0',
    imageUrlPlaceholder: 'https://ejemplo.com/imagen.jpg',
    productImage: 'Imagen del Producto',
    productImages: 'Imágenes del Producto',
    selectImage: 'Seleccionar Imagen',
    selectImages: 'Seleccionar Imágenes',
    uploading: 'Subiendo',
    remove: 'Eliminar',
    primary: 'Principal',
    setAsPrimary: 'Marcar como principal',
    moveUp: 'Mover arriba',
    moveDown: 'Mover abajo',
    multipleImagesHint: 'Puedes seleccionar múltiples imágenes a la vez',
    allowedFormats: 'Formatos permitidos',
    invalidFileType: 'Tipo de archivo inválido. Solo se permiten imágenes JPG, PNG, GIF y WebP.',
    fileSizeTooLarge: 'El archivo es demasiado grande. El tamaño máximo es 10MB.',
    errorUploadingImage: 'Error al subir la imagen. Por favor intenta de nuevo.',

    // Categories
    manageCategoriesText: 'Organiza tus productos en categorías',
    newCategory: '+ Nueva Categoría',
    totalCategoriesLabel: 'Total Categorías',
    mainCategories: 'Categorías Principales',
    subcategories: 'Subcategorías',
    searchByNameOrSlug: 'Buscar por nombre o slug...',
    noCategoriesFound: 'No se encontraron categorías',

    // Common
    loading: 'Cargando...',
    error: 'Error',
    retry: 'Reintentar',
    close: 'Cerrar',
    save: 'Guardar',
    deleteConfirm: '¿Estás seguro de que quieres eliminar este producto?',
    errorDeletingProduct: 'Error al eliminar el producto',
    errorSavingProduct: 'Error al guardar el producto',
    loadingProducts: 'Cargando productos...',
    inStockLabel: 'En stock',
    outOfStockLabel: 'Sin stock',
  },
  en: {
    // Auth
    backofficeTitle: 'Store Backoffice',
    loginSubtitle: 'Choose your access method',
    continueWithGoogle: 'Continue with Google',
    continueWithEmail: 'Continue with Email',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    emailPlaceholder: 'you@email.com',
    passwordPlaceholder: '••••••••',
    login: 'Login',
    loggingIn: 'Logging in...',
    register: 'Register',
    registering: 'Registering...',
    noAccount: "Don't have an account?",
    createAccount: 'Create account',
    alreadyHaveAccount: 'Already have an account?',
    signIn: 'Sign in',
    backToOptions: 'Back to options',
    loginFailed: 'Login failed',
    googleLoginFailed: 'Google login failed',
    invalidCredentials: 'Invalid email or password',
    passwordsDoNotMatch: 'Passwords do not match',
    registrationFailed: 'Registration failed',

    // Navigation
    dashboard: 'Dashboard',
    products: 'Products',
    categories: 'Categories',
    orders: 'Orders',
    logout: 'Logout',

    // Dashboard
    welcomeBackoffice: 'Welcome to the store backoffice',
    totalProducts: 'Total Products',
    inStock: 'In Stock',
    outOfStock: 'Out of Stock',
    catalogSummary: 'Catalog Summary',
    totalCategories: 'Categories',
    activeCategories: 'Active categories',
    availableProducts: 'Available products',
    productsOutOfStock: 'Out of stock products',
    quickActions: 'Quick Actions',
    viewAllProducts: 'View all products',
    manageCategories: 'Manage categories',
    viewOrders: 'View orders',

    // Products
    manageProducts: 'Manage your product catalog',
    newProduct: '+ New Product',
    searchByName: 'Search by name...',
    allStatuses: 'All statuses',
    withStock: 'With stock',
    noStock: 'No stock',
    product: 'Product',
    category: 'Category',
    price: 'Price',
    status: 'Status',
    actions: 'Actions',
    noProductsFound: 'No products found',
    view: 'View',
    delete: 'Delete',
    showing: 'Showing',
    of: 'of',

    // Product Form
    editProduct: 'Edit Product',
    createProduct: 'Create Product',
    name: 'Name',
    description: 'Description',
    stock: 'Stock',
    selectCategory: 'Select a category',
    imageUrl: 'Image URL',
    cancel: 'Cancel',
    update: 'Update',
    create: 'Create',
    namePlaceholder: 'Product name',
    descriptionPlaceholder: 'Product description',
    pricePlaceholder: '0.00',
    stockPlaceholder: '0',
    imageUrlPlaceholder: 'https://example.com/image.jpg',
    productImage: 'Product Image',
    productImages: 'Product Images',
    selectImage: 'Select Image',
    selectImages: 'Select Images',
    uploading: 'Uploading',
    remove: 'Remove',
    primary: 'Primary',
    setAsPrimary: 'Set as primary',
    moveUp: 'Move up',
    moveDown: 'Move down',
    multipleImagesHint: 'You can select multiple images at once',
    allowedFormats: 'Allowed formats',
    invalidFileType: 'Invalid file type. Only JPG, PNG, GIF and WebP images are allowed.',
    fileSizeTooLarge: 'File is too large. Maximum size is 10MB.',
    errorUploadingImage: 'Error uploading image. Please try again.',

    // Categories
    manageCategoriesText: 'Organize your products into categories',
    newCategory: '+ New Category',
    totalCategoriesLabel: 'Total Categories',
    mainCategories: 'Main Categories',
    subcategories: 'Subcategories',
    searchByNameOrSlug: 'Search by name or slug...',
    noCategoriesFound: 'No categories found',

    // Common
    loading: 'Loading...',
    error: 'Error',
    retry: 'Retry',
    close: 'Close',
    save: 'Save',
    deleteConfirm: 'Are you sure you want to delete this product?',
    errorDeletingProduct: 'Error deleting product',
    errorSavingProduct: 'Error saving product',
    loadingProducts: 'Loading products...',
    inStockLabel: 'In stock',
    outOfStockLabel: 'Out of stock',
  },
}

export type Language = keyof typeof translations
export type TranslationKey = keyof typeof translations.es
